import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import videojs from 'video.js';
// import Player from 'video.js/dist/types/player';

// let apiLoaded = false;

@Component({
  selector: 'hh-youtube-video-player',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './youtube-video-player.component.html',
  styleUrls: ['./youtube-video-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeVideoPlayerComponent implements OnInit, OnDestroy {
  @Input()
  public videoId!: string;

  @ViewChild('target', { static: true })
  private target!: ElementRef;

  // private player?: Player;

  public ngOnInit(): void {
    // this.loadYouTubeAPI().then(() => {
      // this.initializePlayer();
    // });
  }

  // private loadYouTubeAPI(): Promise<void> {
  //   return new Promise((resolve) => {
  //     if ((window as any).YT) {
  //       // YT is already loaded
  //       resolve();
  //     } else {
  //       // Load the API
  //       const tag = document.createElement('script');
  //       tag.src = 'https://www.youtube.com/iframe_api';
  //       const firstScriptTag = document.getElementsByTagName('script')[0];
  //       firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
  //
  //       // Wait for the API to load
  //       (window as any).onYouTubeIframeAPIReady = () => resolve();
  //     }
  //   });
  // }

  // private initializePlayer(): void {
  //   this.player = videojs(this.target.nativeElement, {
  //     autoplay: true,
  //     width: 1920,
  //     height: 1080,
  //     techOrder: ['youtube'],
  //     sources: [
  //       {
  //         type: 'video/youtube',
  //         src: `https://www.youtube.com/watch?v=${this.videoId}`
  //       }
  //     ]
  //   });
  //
  //   this.player.ready(() => {
  //     this.player?.muted(true);
  //     this.player?.play();
  //   });
  //
  //   this.player.on('play', () => {
  //     this.player?.muted(false);
  //   });
  // }

  public ngOnDestroy(): void {
    // this.player?.dispose();
  }
}
